export const fr = {
  common: {
    forms: {
      required: 'Ce champ est obligatoire',
      optional: 'Optionnel',
      invalidFormat: 'Format invalide',
      emailConfirmMismatch: 'Les adresses email ne correspondent pas',
      format: {
        email: "L'adresse email n'est pas valide",
        name: "Le format du nom n'est pas valide",
        phoneNumber: 'Le format du numéro de téléphone est invalide',
        siret: 'Un numéro de SIRET comprend 14 chiffres',
        type: {
          number: 'Veuillez saisir un nombre',
        },
      },
    },
    apiError: 'Une erreur est survenue',
    next: 'Suivant',
    previous: 'Précédent',
    close: 'Fermer',
    back: 'Retour',
    startSubscription: 'Commencer la souscription',
    link: {
      priceList: 'https://www.mylight150.com/offres-d-energie',
      encoreOffer: 'https://www.mylight150.com/encore',
      preloadedBatteryOffer: 'https://www.mylight150.com/batterie-davance',
    },
  },
  subscription: {
    common: {
      api: {
        errors: {
          getSubscription: 'Erreur lors de la récupération de la souscription',
        },
      },
    },
    pdl: {
      title: 'Produisez, stockez et pilotez votre énergie.',
      description:
        'Rejoignez +35 000 foyers équipés.<br /> Souscription en quelques minutes. Nous nous occupons de résilier votre ancien contrat (sans coupure).',
      tags: {
        time: '10 min',
        withoutEngagement: 'Sans engagement',
      },
      startSubscription: 'Commencer votre souscription',
      enterPdl: 'Saisissez votre numéro PDL ou PRM pour identifier votre logement.',
      infoAlert: {
        title:
          "Notre offre d'électricité est uniquement compatible avec le Gestionnaire de Réseau de Distribution Enedis (95% des foyers français).",
      },
      input: {
        label: 'PDL ou PRM',
        placeholder: '23230535371298',
        helper: {
          format: 'Format invalide. Le PDL (ou PRM) est un nombre à 14 chiffres',
          unknownPdl:
            "PDL/PRM non reconnu. Vérifiez votre saisie ou contactez notre service client (support{'@'}mylight150.com ou au +33 4 84 31 00 20).",
          unavailablePdl:
            "Votre PDL/PRM n’est pas compatible avec notre offre. Vérifiez votre saisie ou contactez notre service client (support{'@'}mylight150.com ou au +33 4 84 31 00 20).",
        },
        tooltip: `<p class="text-center font-bold mb-4">Où retrouver le PDL ou PRM ?</p>
        <ul class="list-disc list-inside">
        <li class='text-center mb-4'>Sur votre compteur Linky : appuyez plusieurs fois sur le bouton “+” jusqu'à ce qu'il s'affiche sur l'écran</li>
        <li class='text-center'>Sur une ancienne facture</li>
        </ul>`,
      },
      toast: {
        500: {
          title: 'Votre PDL/PRM n’a pas pu être vérifé',
          description: 'Nous rencontrons un problème technique. Veuillez réessayer',
        },
        default: 'Une erreur est survenue',
        422: {
          mbContractNumberMandatory: {
            title: 'Le PDL renseigné est lié à un contrat actif',
            description:
              "Veuillez contacter le support par téléphone au +33 4 84 31 00 20 ou par email à support{'@'}mylight150.com",
          },
        },
      },
      errorAlert: {
        technicalError: {
          title: 'Nous rencontrons un problème technique',
          description:
            "Veuillez réessayer. Si le problème persiste, contactez-nous par téléphone au <b>+33 4 84 31 00 20</b> ou par email à <b>support{'@'}mylight150.com</b>",
        },
      },
    },
    contractNumber: {
      title: 'Renseignez votre numéro de contrat mylight150',
      alertInfoSubscriptionLinkedToMove: {
        title: 'Il s’agit d’une souscription liée à un déménagement ?',
        description:
          "Veuillez contacter notre service client (support{'@'}mylight150.com ou au +33 4 84 31 00 20) qui s’occupera d’effectuer les démarches avec vous.",
      },
      alertSuccessExistingContract: {
        title: 'Vous avez un contrat d’énergie actif chez nous',
        description:
          'Veuillez saisir votre numéro de contrat. En poursuivant la souscription, votre contrat actuel sera automatiquement résilié.',
      },
      input: {
        label: 'Numéro de contrat mylight150',
        tooltip: 'Votre numéro de contrat est à retrouver sur votre facture d’énergie mylight150.',
        helper: {
          info: 'Exemple : RES00000000 ou PRO00000000',
          unknownContractNumber:
            "Numéro de contrat inconnu. Vérifiez votre saisie ou contactez notre service client (support{'@'}mylight150.com ou au +33 4 84 31 00 20).",
        },
        placeholder: 'RES00000000',
      },
      toast: {
        500: {
          title: 'Votre numéro de contrat n’a pas pu être vérifé',
          description: 'Nous rencontrons un problème technique. Veuillez réessayer',
        },
        default: 'Une erreur est survenue',
      },
    },
    installationAddress: {
      title: "Renseignez votre adresse d'installation",
      form: {
        address: {
          label: 'Adresse',
          placeholder: '1 Rue Hippolyte Kahn',
        },
        addressComplement: {
          label: "Complément d'adresse",
          placeholder: 'Allée B',
        },
        zipCode: {
          label: 'Code postal',
          placeholder: '69100',
        },
        city: {
          label: 'Ville',
          placeholder: 'Villeurbanne',
        },
        activeContract: {
          label: 'Contrat en cours',
          question:
            "Avez-vous actuellement un contrat d'électricité actif sur ce logement avec un autre fournisseur ?",
          options: {
            yes: 'Oui',
            no: 'Non',
          },
        },
      },
      api: {
        errors: {
          patchSubscriptionInstallationAddress:
            "Erreur lors de la sauvegarde de l'adresse de souscription",
          patchSubscriptionCustomerDeclarations:
            'Erreur lors de la sauvegarde de votre contrat en cours',
        },
      },
    },
    equipments: {
      title: 'Renseignez votre profil',
      yourSituation: 'Votre situation',
      yoursEquipments: 'Vos équipements',
      form: {
        solarPanels: {
          label: 'Êtes-vous équipé de panneaux photovoltaïques ?',
          alreadyEquipped: 'Oui, j’en ai déjà',
        },
        robinDevice: {
          label: 'Êtes-vous équipé de Robin, notre coffret de pilotage mylight150 ?',
          helperLinkLabel: 'En savoir plus sur le coffret Robin',
          alreadyEquipped: "Oui, j'en ai un",
        },
        physicalBattery: {
          label: 'Êtes-vous équipé d’une batterie physique ?',
          alreadyEquipped: "Oui, j'en ai une",
        },
        evCharger: {
          label: 'Êtes-vous équipé d’une borne de recharge mylight150 ?',
          alreadyEquipped: "Oui, j'en ai une",
        },
        mainHeatingSource: { label: 'Chauffage principal' },
        waterHeatingSource: { label: 'Eau chaude sanitaire' },
        otherEquipments: { label: 'Autres équipements du logement' },
      },
      choices: {
        PlannedInstallation: "Pas encore, mais c'est prévu",
        NotEquipped: 'Non',
        AlreadyEquipped: {
          solarPanels: 'Oui, j’en ai déjà',
          robinDevice: "Oui, j'en ai un",
          physicalBattery: "Oui, j'en ai une",
          evCharger: "Oui, j'en ai une",
        },
      },
      options: {
        mainHeatingSource: {
          AirToWaterHeatPump: {
            title: 'Pompe à chaleur air-eau',
            description: 'Exemples : radiateur à eau ou plancher chauffant',
          },
          AirToAirHeatPump: {
            title: 'Pompe à chaleur air-air',
            description: 'Exemple : climatisation réversible',
          },
          ElectricRadiators: { title: 'Radiateurs électriques' },
          NoElectric: { title: 'Non électrique', description: 'Exemple : gaz, fioul' },
        },
        waterHeatingSource: {
          ElectricWaterHeater: {
            title: 'Chauffe-eau électrique',
            description: "Exemple : ballon d'eau chaude classique (cumulus)",
          },
          ThermodynamicWaterHeater: {
            title: 'Chauffe-eau thermodynamique',
            description: "Exemple : ballon d'eau chaude avec pompe à chaleur intégrée",
          },
          HeatPump: {
            title: 'Pompe à chaleur',
            description: 'Exemple : pompe à chaleur air/eau (double service)',
          },
          NoElectric: { title: 'Non électrique', description: 'Exemple : gaz, fioul' },
        },
        otherEquipments: {
          AirConditioning: { title: 'Climatisation' },
          Fireplace: { title: 'Cheminée, poêle' },
          ElectricalVehicle: { title: 'Véhicule 100% électrique' },
          HybridVehicle: { title: 'Véhicule hybride rechargeable' },
          SwimmingPool: { title: 'Piscine' },
          Spa: { title: 'Spa' },
        },
      },
      api: {
        errors: {
          patchSubscriptionConsumption: 'Erreur lors de la sauvegarde de votre profil',
        },
      },
      robinDeviceAlertInfo: {
        title: 'Robin, pour aller plus loin dans votre autonomie',
        description:
          "Pas encore équipé ? Sachez qu'avec Robin, nos clients cagnottent ~500€/an grâce au pilotage intelligent de leurs équipements (chauffe-eau électrique, pompe à chaleur air-eau, borne de recharge mylight150) et peuvent suivre toutes leurs données de consommation et de production en temps réel.",
      },
      robinDeviceHelperModal: {
        title: "Robin, notre coffret de pilotage et d'intelligence énergétique",
        content: {
          whatIsRobin: {
            description:
              "Robin est <b>notre système d'intelligence énergétique.</b> Il pilote la maison pour synchroniser en temps réel :",
            list: `<li>la production solaire,</li>
                  <li>la consommation des équipements.</li>`,
          },
          deviceForms: {
            description:
              "Il se présente soit sous forme d'un coffret mylight150 (image 1) ou peut être intégré directement dans votre tableau électrique (image 2).",
            box: {
              label: 'Image 1',
              title: 'Coffret Robin',
            },
            core: {
              label: 'Image 2',
              title: 'Robin Core intégré au tableau',
            },
          },
        },
      },
    },
    impossibleToSubscribe: {
      title: "Nous ne proposons pas (encore) d'offre de fourniture seule.",
      description:
        "Aujourd'hui, nos offres de fourniture d'énergie fonctionnent en duo avec nos solutions de stockage virtuel ou de pilotage intelligent.",
      plannedInstallation: {
        label: 'Vous avez une installation programmée ?',
        text: 'Revenez souscrire une fois votre installation réalisée.',
      },
      noEquipment: {
        label: "Pas encore d'équipement ?",
        text: 'Découvrez nos solutions ci-dessous :',
      },
      virtualStorage: {
        title: 'Stockage virtuel',
        description:
          "Avec une batterie virtuelle, l'électricité solaire que vous produisez en trop peut être récupérée plus tard, même quand le soleil ne brille plus.",
        link: 'Découvrir notre offre',
      },
      smartPiloting: {
        title: 'Pilotage intelligent',
        description:
          'Grâce à Robin, notre coffret connecté, votre maison adapte sa consommation en fonction du réseau et de votre production solaire.',
        link: 'Découvrir notre offre',
      },
    },
    solarInstallation: {
      title: 'Renseignez votre installation solaire',
      form: {
        installedPowerInkWc: {
          label: 'Quelle est la puissance photovoltaïque totale installée ?',
          helper: {
            info: 'La puissance totale installée ne peut pas être supérieure à 100kWc.',
          },
        },
        installationPerformedBy: {
          label: 'Votre installation photovoltaïque est réalisée',
          options: {
            ProfessionalInstaller: 'Par un installateur professionnel',
            SelfInstalled: 'Par moi-même (en auto-pose)',
          },
        },
        yourInstaller: {
          title: 'Votre installateur',
        },
      },
      selfInstalledInfoAlert: {
        title: "Nous vous accompagnons dans vos démarches d'activation.",
        description:
          "En tant qu'autoposeur, quelques étapes sont nécessaires pour activer votre batterie virtuelle. Depuis votre espace client mylight150, après la signature de votre contrat, nous vous guiderons pas à pas.",
      },
    },
    installerForm: {
      infoAlert: {
        title:
          "Aidez nous à prendre contact avec votre installateur pour récupérer les informations nécessaires à l'activation de votre offre.",
      },
      companyNameInput: {
        label: 'Nom de la société',
        placeholder: 'Solar Expedition',
      },
      companySiretInput: {
        label: 'SIRET',
      },
      companyEmailInput: {
        label: 'Adresse email de votre installateur',
        placeholder: "installateurpv{'@'}mail.com",
      },
    },
    installerInformations: {
      title: 'Renseignez le contact de votre installateur',
      api: {
        errors: {
          patchSubscriptionInstallation:
            "Erreur lors de la sauvegarde des informations de l'installateur",
        },
      },
    },
    physicalBattery: {
      api: {
        errors: {
          getPhysicalBatteries: 'Erreur lors de la récupération des marques de batteries physiques',
          patchSubscriptionPhysicalBattery:
            'Erreur lors de la sauvegarde de votre batterie physique',
        },
      },
      title: 'Renseignez votre batterie physique',
      subtitle:
        'Ces informations nous permettent de vérifier si votre batterie est pilotable par mylight150',
      form: {
        brand: {
          label: 'Quelle est la marque de votre batterie physique ?',
          placeholder: 'Sélectionnez une marque',
          options: {
            Atmoce: 'Atmoce',
            EnphaseAcb: 'Enphase (modèle ACB)',
            EnphaseOther: 'Enphase (Autres modèles)',
            Fox: 'Fox',
            Huawei: 'Huawei',
            Solplanet: 'Solplanet',
            Tesla: 'Tesla',
            Other: 'Autre',
          },
        },
        capacity: {
          label: 'Quelle est la capacité totale installée ?',
          placeholder: 'Ex. 8',
          helper: {
            info: 'Additionnez les capacités si vous avez plusieurs modules',
            min: 'La capacité totale doit être supérieure ou égale à {min} kWh.',
            decimals: 'La capacité totale ne peut avoir qu’une seule décimale.',
          },
        },
      },
      encore: {
        tag: 'Offre ENCORE',
        compatible: {
          title:
            'Jusqu’à {maxDiscount} de réduction par mois sur votre abonnement de batterie virtuelle',
          description:
            'Grâce à votre batterie {brand} de {capacity} kWh, compatible avec mylight150 : {mySmartBatteryRate}/mois par kWh de batterie physique installée avec MySmartBattery, {myBatteryRate}/mois avec MyBattery.',
        },
        brandNotCompatible: {
          title: 'Pilotage de votre batterie physique',
          description:
            'Votre batterie {brand} n’est pas encore compatible. Nous ajoutons progressivement de nouvelles marques : restez connecté pour profiter plus tard de cette offre.',
        },
        capacityTooLow: {
          title: 'Pilotage de votre batterie physique',
          description:
            'Votre batterie {brand} de {capacity} kWh n’est pas compatible. Seules les capacités égales ou supérieures à {minimumCapacity} kWh permettent de bénéficier de l’offre Encore.',
        },
        learnMore: 'En savoir plus sur l’offre Encore',
      },
      howEncoreWorksModal: {
        title: 'Comment fonctionne l’offre Encore',
        intro:
          'L’offre Encore réduit votre abonnement de batterie virtuelle parce que votre batterie physique est pilotable par mylight150. Voici comment elle se met en place :',
        steps: [
          '1 - Vous souscrivez à votre batterie virtuelle',
          '2 - Dans l’application mylight150, vous liez le compte du fabricant de votre batterie physique et vous acceptez le partage des données.',
          '3 - Nous vérifions auprès du fabricant la capacité installée et validons la réduction automatiquement',
          '4 - La réduction s’applique sur votre facture dès le mois en cours',
        ],
      },
    },
    solarProductionStorage: {
      title: 'Stockez votre production solaire',
      description: "Deux options de stockage virtuel pensées pour s'adapter à votre consommation.",
      requiredError: 'Veuillez sélectionner une option pour continuer.',
      tags: {
        withoutEngagement: 'Sans engagement',
        popularOption: 'Option populaire',
        recommended: 'Populaire',
      },
      preloadedBatteryOfferAlert: {
        title: "Promo hiver - une batterie d'avance dès le premier jour",
        description:
          "Souscrivez cet hiver, démarrez le 1er avril avec une batterie virtuelle déjà pleine. En attendant, vous restez chez votre fournisseur d'électricité actuel.",
        link: "Plus de détails sur l'offre Batterie d'avance",
      },
      batteryStorage: {
        common: {
          storage: 'Stockage',
          restitution: 'Restitution',
          priceUnit: 'TTC/mois',
          offered: 'Offert',
          buttonSelected: 'Option sélectionnée',
          buttonSelect: 'Je sélectionne cette option',
        },
        mySmartBattery: {
          name: 'MYSMARTBATTERY',
          subtitle: 'Stockage sur-mesure',
          description: 'Devenez 100% autonome plusieurs mois par an.',
          storageText: 'Dimensionné',
          storageDescription: 'Charges & décharges illimitées',
          restitutionText: 'Gratuite',
          restitutionDescription: '1kWh stocké = 1kWh restitué',
          alertText:
            "Idéal si votre consommation est régulière toute l'année - piscine, climatisation ou autres équipements qui tournent l'été.",
          selectLabel: 'Choisissez votre capacité de stockage',
          selectPlaceholder: 'Séléctionner une capacité',
          priceNote: "pour {msbCapacitySelected} kWh · sans frais d'acheminement",
          modifiableLink: 'Ma capacité de stockage est-elle modifiable plus tard ?',
          modifiableModal: {
            title: 'Ma capacité de stockage est-elle modifiable plus tard ?',
            intro: 'Oui, depuis votre espace client mylight150, à tout moment :',
            listItems: {
              increase: {
                term: 'Augmenter ma capacité de stockage',
                description: ' : possible à tout moment',
              },
              reduce: {
                term: 'Réduire ma capacité de stockage',
                description: ' : possible 12 mois après la dernière modification',
              },
            },
            outro: 'Toute modification est effective le 1er du mois suivant.',
            limitedReduction: {
              title: 'Pourquoi la réduction est-elle limitée ?',
              description:
                "Notre tarif est calculé sur un cycle annuel complet, comme une batterie physique. C'est aussi le temps nécessaire pour connaître vraiment vos besoins : production, consommation, saisons. Une année complète vous donnera une vision claire pour ajuster au plus juste.",
            },
            startWith100: {
              title: 'Vous hésitez ? Débutez avec la 100kWh',
              description:
                "100 kWh est la capacité de départ que nous recommandons car elle vous permet d'évaluer vos besoins réels avant d'ajuster.",
            },
          },
        },
        myBattery: {
          name: 'MYBATTERY',
          subtitle: 'Stockage illimité',
          description: 'Récupérez tout votre surplus solaire à ~10cts/kWh.',
          storageText: 'Aucun plafond',
          storageDescription: 'En capacité et en durée',
          restitutionDescription: "~2× moins cher que l'électricité du réseau",
          alertText:
            "Idéal si votre consommation suit les saisons : faible l'été, forte l'hiver - sans gros équipements qui tournent l'été.",
          installationInfo:
            "Nous avons pris en compte votre installation de {installedPowerInkWc} kWc ({monthlyPricePerkWc}/kWc/mois), hors frais d'acheminement sur les kWh restitués.",
          priceNote: "pour {installedPowerInkWc} kWc · + frais d'acheminement",
          shippingLink: "En savoir plus sur les frais d'acheminement",
        },
        noStorage: {
          title: "Je ne suis pas intéressé par l'option de stockage virtuel",
        },
      },
      error: {
        findBatteryChoices: {
          title: 'Erreur lors de la récupération des tarifs',
          content: 'Impossible de récupérer les tarifs des options de stockage virtuel.',
        },
        saveBatteryOption: {
          title: 'Erreur lors de la sauvegarde',
          content: "Impossible d'enregistrer votre choix de stockage. Veuillez réessayer.",
        },
        installedPowerInkWcNotFound: {
          title: 'Erreur lors de la recuperation de la puissance installée',
          content: 'La puissance installée est introuvable.',
        },
      },
    },
    cashbackActivation: {
      title: 'Activez votre cagnotte mylight150',
      description: '~500€/an grâce au pilotage intelligent de vos équipements.',
      tags: {
        freeOption: 'Option gratuite',
        withoutEngagement: 'Sans engagement',
      },
      heroCard: {
        titleSingular: 'Votre équipement vous rapporte',
        titlePlural: 'Vos équipements vous rapportent',
        perYear: '/an',
      },
      details: {
        title: 'Détail de la cagnotte',
        heatPump: {
          name: 'Pompe à chaleur air-eau',
          rate: '+5cts€ par kWh consommé et piloté',
          amount: '+250€/an',
        },
        waterHeater: {
          name: 'Chauffe-eau électrique',
          rate: '+5cts€ par kWh consommé et piloté',
          amount: '+100€/an',
        },
        charger: {
          name: 'Borne de recharge mylight150',
          rate: 'Entre +5cts€ et +10cts€ par kWh à chaque recharge le week-end',
          amount: '+150€/an',
        },
        alert:
          "Le saviez-vous ? La cagnotte peut atteindre ~500€/an avec la pose d'une borne de recharge mylight150.",
        link: 'Comment fonctionne le pilotage intelligent ?',
        linkUrl: 'https://help.mylight150.com/fr/articles/497491-comprendre-mysmartpilot',
      },
      form: {
        label: 'Souhaitez-vous bénéficier du pilotage intelligent et de la cagnotte mylight150 ?',
        accept: {
          text: [
            "J'active gratuitement mon pilotage intelligent et j'accepte les ",
            ". J'autorise mylight150 et son partenaire Survoltage à optimiser ma consommation pour maximiser mes gains, tout en respectant la confidentialité de mes données.",
          ],
          conditionsLink: "conditions d'autorisation détaillée",
        },
        decline: 'Je ne souhaite pas bénéficier du pilotage intelligent et de la cagnotte',
        error: 'Information obligatoire',
      },
      conditionsModal: {
        title: 'Conditions d’autorisation MySmartPilot',
        content: [
          'En cochant cette case, ',
          'J’autorise mylight150 et son partenaire Survoltage à : ',
          'Réaliser des modulations de consommation à la hausse et à la baisse sur mes équipements pilotés dans le cadre de MySmartPilot, pour les valoriser sur les marchés',
          'Transmettre à au gestionnaire public de transport d’électricité (RTE) mes données de consommation et à utiliser les données de télémesure de mon site de consommation',
          'Indiquer aux gestionnaires de réseau concernés l’identité de mon fournisseur d’électricité et à leur notifier tout changement',
          'J’autorise le Gestionnaire de Réseau (GRD) auquel mon site de consommation est raccordé à : ',
          'Collecter mes données de consommation et de production au pas de temps 15 minutes, les index quotidiens en kWh, les puissances atteintes en kVA, les données contractuelles',
          'Fournir à mylight150 et son partenaire Survoltage, et à RTE le cas échéant, les données de consommation et de production collectées',
          'Fournir à RTE mes données contractuelles (fournisseur, responsable d’équilibre, puissance souscrite…) nécessaires à la réalisation de modulations de consommation',
          'J’autorise RTE à réaliser des audits des systèmes de mesure et de transmission mis en place ainsi qu’à contrôler la chaîne de commande des modulations de consommation mise en place sur mon installation, y compris lors d’expérimentations.',
          "Cette autorisation est valable pendant la durée de souscription à l'option gratuite MySmartPilot de mylight150.",
        ],
        close: 'Fermer',
      },
      api: {
        errors: {
          patchSubscriptionEquipmentControlOptions:
            "Erreur lors de l'enregistrement du choix pour l'activation du pilotage",
        },
      },
    },
    electricityConsumption: {
      title: "Renseignez votre consommation d'électricité",
      form: {
        radioGroupCards: {
          label: 'Consommation annuelle',
          units: {
            kilowattHours: 'En kWh',
            euros: 'En € (TTC)',
          },
        },
        unitInputs: {
          kilowattHours: {
            label: 'Consommation annuelle (en kWh)',
            tooltip:
              'Retrouvez votre consommation annuelle sur la facture de votre fournisseur actuel.',
            placeholder: '2000',
          },
          euros: {
            label: 'Consommation annuelle (en €)',
            tooltip: 'Retrouvez ce montant sur la facture de votre fournisseur actuel.',
            placeholder: '2000',
          },
        },
      },
    },
    billingMode: {
      api: {
        errors: {
          patchSubscriptionDirectDebit: 'Erreur lors de la sauvegarde du mode de facturation',
          BUDGET_BREAKDOWN_NOT_GENERATED: 'Échéancier non généré.',
          MY_BATTERY_OPTION_NOT_COMPATIBLE_WITH_REALTIME_DIRECT_DEBIT_MODE:
            "L'option MyBattery n'est pas compatible avec le mode de facturation au réel.",
          INVALID_LINEAR_MONTHLY_PAYMENT: 'Montant de la mensualité invalide.',
        },
      },
      title: 'Choisissez votre mode de facturation',
      linearOrRealTime: {
        subtitle: 'Choix du mode de facturation',
        descriptionLink: {
          title: 'Quel mode de facturation choisir ?',
          link: 'https://help.mylight150.com/fr/articles/497439-quel-mode-de-facturation-choisir',
        },
        linear: {
          label: 'Échéancier Linéaire',
          description:
            'Vous payez le même montant chaque mois, puis vous recevrez une facture de régularisation après 1 an.',
        },
        realTime: {
          label: 'Facturation au réel',
          description:
            'Vous payez chaque mois votre consommation réelle, en fonction du relevé de votre compteur.',
        },
      },
      linearOnly: {
        title: 'Échéancier linéaire',
        description:
          'Vous payez le même montant chaque mois, puis vous recevrez une facture de régularisation après 1 an.',
      },
      monthlyPayment: {
        label: 'Choix de votre mensualité (TTC)',
        noMonthlyPaymentFound: {
          title: 'Erreur lors de la recuperation des mensualités de prélèvement',
          content:
            "Impossible de vous proposer des mensualités de prélèvement. Veuillez contacter notre service client (support{'@'}mylight150.com ou au +33 4 84 31 00 20).",
        },
      },
      annualBudget: {
        title: 'Votre budget annuel d’électricité estimé',
        description: 'Sur la base de vos informations saisies.',
        promotionalDescription: {
          firstYear: 'la première année, grâce à l’offre de bienvenue',
        },
        unit: '/an (TTC)',
        price: 'Gratuit | {value}/an | {value}/an',
        discountPerYear: '-{value}/an',
        pricePerMonth: '{value}/mois',
        detailLink: 'Voir le détail de mon budget',
        kWh: '{number} kWh',
        kVA: '{number} kVA',
        vat: ' TTC',
        modal: {
          title: 'Voir le détail de mon budget',
          link: ['Pour en savoir plus, vous pouvez', 'consulter notre grille tarifaire'],
          energyPrice: {
            title: 'Prix de l’énergie',
            content: 'Votre consommation d’électricité :',
            detail:
              "*Ce calcul tient compte de l'autoconsommation (si vous avez des panneaux solaires) et de la batterie virtuelle (si vous avez souscrit l’option).",
          },
          subscription: {
            title: 'Abonnement',
            content: [
              "Votre abonnement de fourniture d'électricité :",
              'Contribution individuelle autoproducteur',
            ],
          },
          options: {
            title: 'Options mylight150',
            content: [
              'Stockage virtuel MySmartBattery :',
              'Stockage virtuel MyBattery',
              'Pilotage intelligent',
            ],
            encoreDiscount: 'Offre Encore : Remise de {value}/mois',
          },
        },
      },
    },
    contractorInformation: {
      title: 'Renseignez vos informations personnelles',
      form: {
        contractorTitle: 'Votre contractant',
        contactTitle: 'Vos informations de contact',
        clientType: {
          label: 'Situation',
          value: {
            individual: 'Particulier',
            company: 'Professionnel',
          },
        },
        individual: {
          contractor: {
            email: { label: 'Adresse email', placeholder: "camille.dupont{'@'}gmail.com" },
            emailConfirm: {
              label: 'Confirmez votre adresse email',
              placeholder: "camille.dupont{'@'}gmail.com",
            },
            firstName: { label: 'Prénom', placeholder: 'Camille' },
            lastName: { label: 'Nom', placeholder: 'Dupont' },
            phoneNumber: { label: 'Téléphone', placeholder: '00 00 00 00 00' },
          },
          isCoContractor: {
            label: 'Avez-vous un co-contractant ?',
            placeholder: "J'ai un co-contractant",
          },
          coContractor: {
            firstName: { label: 'Prénom du co-contractant', placeholder: 'Jean' },
            lastName: { label: 'Nom du co-contractant', placeholder: 'Dupont' },
          },
        },
        company: {
          companyName: { label: 'Raison sociale', placeholder: 'Solaire Construction' },
          siret: {
            label: 'SIRET',
            placeholder: '123 456 789 00000',
            format: 'Le format du SIRET est invalide (14 chiffres)',
          },
          codeNAF: {
            label: 'Code NAF',
            placeholder: '4561E',
            format: 'Le format du code NAF est invalide (4 chiffres + 1 lettre majuscule)',
          },
          intraCommunityVATNumber: {
            label: 'TVA intracommunautaire',
            placeholder: 'FR12345678901',
          },
          contact: {
            email: { label: 'Adresse email', placeholder: "camille.dupont{'@'}gmail.com" },
            emailConfirm: {
              label: 'Confirmez votre adresse email',
              placeholder: "camille.dupont{'@'}gmail.com",
            },
            firstName: { label: 'Prénom du représentant légal', placeholder: 'Camille' },
            lastName: { label: 'Nom du représentant légal', placeholder: 'Dupont' },
            phoneNumber: { label: 'Téléphone', placeholder: '00 00 00 00 00' },
          },
        },
      },
      api: {
        errors: {
          patchSubscriptionContractorIndividual:
            'Erreur lors de la sauvegarde des informations du contractant',
          patchSubscriptionContractorCompany:
            'Erreur lors de la sauvegarde des informations de la société',
        },
      },
    },
    billingInformations: {
      title: 'Renseignez vos coordonnées de paiement',
      alert: {
        monthlyAmount: "Vos mensualités s'élèvent à {amount}€/mois.",
        description:
          'La première mensualité sera prélevée 5 jours après la signature de votre contrat, puis le 10 de chaque mois.',
      },
      form: {
        accountName: {
          label: 'Nom du titulaire du compte',
          placeholder: 'Camille Dupont',
        },
        iban: {
          label: 'IBAN',
          placeholder: 'FR00 0000 0000 0000 0000 0000 000',
          helper: "Le format de l'IBAN renseigné est incorrect.",
          countryHelper: 'IBAN hors SEPA non accepté',
        },
        bic: {
          label: 'BIC',
          placeholder: 'X0X0X0X0',
          helper: 'Le format du BIC renseigné est incorrect.',
        },
        isBillingAddress: {
          label: 'Adresse de facturation',
          placeholder: "Différente de l'adresse de l'installation",
        },
        billingAddress: {
          address: {
            label: 'Adresse',
            placeholder: '8 rue du Prinal',
          },
          addressComplement: {
            label: "Complément d'adresse",
            placeholder: "Complément d'adresse",
          },
          zipCode: {
            label: 'Code postal',
            placeholder: '69000',
          },
          city: {
            label: 'Ville',
            placeholder: 'Lyon',
          },
        },
      },
      api: {
        errors: {
          patchSubscriptionBillingInformations:
            'Erreur lors de la sauvegarde des coordonnées de paiement',
        },
      },
    },
    informationsSummary: {
      title: 'Récapitulatif de votre souscription',
      cardTitle: 'Finalisez votre souscription',
      edit: 'Modifier',
      summaryBox: {
        linear: {
          label: 'Vos mensualités',
          unit: '/mois (TTC)',
        },
      },
      options: {
        title: 'Vos options',
        battery: {
          mySmartBattery: {
            title: 'Stockage virtuel sur-mesure',
            subtitle: 'Devenez 100% autonome plusieurs mois par an.',
            tagBattery: 'MySmartBattery',
            tagCapacity: 'Capacité : {size} kWh',
          },
          myBattery: {
            title: 'Stockage virtuel illimité',
            subtitle: 'Récupérez tout votre surplus solaire à ~10cts/kWh.',
            tagBattery: 'MyBattery',
            tagCapacity: 'Aucun plafond',
          },
          encoreDiscountTag: 'Réduction Encore : {value}/mois',
        },
        pilotage: {
          title: '+{amount}€/an dans votre cagnotte',
          subtitle: 'Grâce au pilotage intelligent de votre équipement',
          tags: {
            airToWaterHeatPump: 'Pompe à chaleur air-eau',
            electricWaterHeater: 'Chauffe-eau électrique',
            electricVehicleCharger: 'Borne de recharge',
          },
        },
      },
      personalInfo: {
        title: 'Vos informations personnelles',
        contractor: 'Contractant(s)',
        coordinates: 'Coordonnées',
        housingAddress: 'Adresse du logement',
      },
      contract: {
        title: 'Votre contrat',
        power: 'Puissance souscrite & offre tarifaire',
        powerValue: '{kVA}kVA - {pricingOption}',
        pricingOption: {
          Base: 'Tarif Base',
          OffPeakAndPeakHours: 'Heures creuses / Heures pleines',
          ExtendedOffPeakAndPeakHours: 'Heures creuses / Heures pleines étendues',
        },
        billingMode: {
          title: 'Mode de facturation',
          text: {
            Linear: 'Échéancier linéaire',
            Realtime: 'Facturation au réel',
          },
          description: {
            Linear:
              'La première mensualité sera prélevée dans 5 jours environ, puis le 10 de chaque mois.',
            Realtime:
              'Votre date de prélèvement dépend du relevé d’index effectué par Enedis. Elle sera fixée une fois ce relevé connu, puis reconduite chaque mois.',
          },
        },
        billingModeValue: {},
        billingModeHelper:
          'La première mensualité sera prélevée dans 7 jours environ, puis le 10 de chaque mois.',
        billingAddress: 'Adresse de facturation',
        iban: 'IBAN',
      },
      alert: {
        activationFees: {
          selfInstalled: {
            title: "Des frais d'activation s'appliquent.",
            description:
              "Pour activer votre batterie virtuelle, des démarches auprès d'Enedis sont nécessaires. Nos équipes prennent tout en charge. Ces frais sont généralement de 279€ (TTC), mais peuvent varier selon votre profil. Ils seront prélevés au moment de la complétion de votre dossier d’activation, depuis votre espace client.",
            link: 'Frais d’activation : combien ça coûte selon votre situation ?',
          },
          professionalInstaller: {
            title: "Des frais d'activation s'appliquent.",
            description:
              "Pour activer votre batterie virtuelle, des démarches auprès d'Enedis sont nécessaires. Ces frais seront prélevés au moment de la complétion de votre dossier d’activation, par votre installateur. Leur montant dépend de votre cas :",
            list: [
              '279€ (TTC) si mylight150 se charge de toutes les démarches.',
              "249€ (TTC) si votre installateur se charge d'une partie des démarches.",
              '99€ (TTC) si vous avez déjà un contrat de valorisation de surplus ailleurs (EDF OA ou autre)',
              '0€ (TTC) si vous êtes déjà client mylight150',
            ],
            link: 'Frais d’activation : combien ça coûte selon votre situation ?',
          },
        },
      },
      promo: {
        title: 'Vous avez un code promo ?',
        placeholder: 'Saisissez votre code',
        apply: 'Appliquer',
        remove: 'Retirer le code',
        invalid: 'Code non valide',
      },
      consents: {
        terms: [
          "J'accepte les",
          'termes et conditions générales de vente',
          'et je renonce à ma période de rétractation de 14 jours.',
        ],
        enedis:
          "J'autorise mylight150 à accéder aux données techniques de mon compteur auprès d'Enedis.",
        installerRecommended: '(Recommandé) ',
        installer:
          "J'autorise mon installateur à accéder à mes données de consommation pour suivre à distance le bon fonctionnement de mon installation et m'alerter en cas d'anomalie.",
        learnMore: 'En savoir plus',
        mandatoryMarker: '*',
        mandatoryFootnote: '* Champs obligatoires',
        requiredError: 'Vous devez accepter les conditions générales de vente pour continuer.',
      },
      submitLabel: 'Valider et signer mon contrat',
      enedisConsentModal: {
        title: 'mylight150 accède aux données techniques de votre compteur Enedis',
        content:
          "En cochant cette case, j'autorise mylight150 à solliciter le gestionnaire du réseau de distribution (Enedis) en mon nom pour obtenir les informations techniques de mon compteur, l'historique des courbes de charge en soutirage et en injection (selon le pas de mesure disponible) et l'activation de la collecte de ces courbes si nécessaire. Ces informations de consommation et d'injection seront disponibles dans mon espace client mylight150.",
        validity:
          'Cette autorisation est valable pendant toute la durée de validité de mon contrat.',
      },
      installerConsentModal: {
        title: 'Votre installateur accède à vos données de consommation',
        content:
          'En cochant cette case, j’autorise mon installateur à accéder à mes données de mesure (consommation, production, autoconsommation) et à certaines données de mon contrat (comme la capacité de ma batterie virtuelle), afin de suivre à distance le bon fonctionnement de mon installation et de détecter rapidement d’éventuelles anomalies.',
        validity:
          'Cette autorisation est valable pendant 2 ans et peut être retirée à tout moment.',
      },
      api: {
        errors: {
          applyPromotionCode: "Erreur lors de l'application du code promo",
          removePromotionCode: 'Erreur lors du retrait du code promo',
          patchSubscriptionConsents: 'Erreur lors de la sauvegarde des consentements',
        },
      },
    },
    contractSignature: {
      title: "Votre contrat d'énergie mylight150",
      titleTag: 'À signer',
      loader: 'Veuillez patienter...',
      api: {
        errors: {
          patchSubscriptionSignature: 'Erreur lors de la signature du contrat',
        },
      },
    },
    contractSigned: {
      title: 'Bienvenue chez mylight150 !',
      subtitle: [
        'Votre contrat est signé. Vous rejoignez ',
        '+35 000 clients',
        ' qui produisent, stockent et pilotent leur énergie.',
      ],
      activateAccount: {
        title: 'Activez votre compte mylight150',
        descriptionBefore: 'Une seule étape : créez votre mot de passe avec ',
        descriptionAfter: ' en cliquant sur « Activer mon compte ».',
        button: 'Activer mon compte',
      },
      nextSteps: {
        title: 'Et maintenant ?',
        disclaimer: '*Délai moyen constaté.',
        email: {
          title: 'Email de confirmation',
          tag: 'Maintenant',
          description: 'Votre contrat vous a été envoyé par email.',
        },
        cashback: {
          title: 'Activation de votre cagnotte',
          tag: '~3 jours ouvrés*',
          description:
            "Bonne nouvelle : Votre cagnotte s'active automatiquement en même temps que votre fourniture d'énergie. Rien à faire de votre côté.",
        },
        energySupply: {
          title: 'Activation de la fourniture d’électricité',
          tag: '~3 jours ouvrés*',
          description:
            'Bonne nouvelle : mylight150 devient officiellement votre fournisseur d’électricité.',
        },
        battery: {
          title: 'Activation de votre batterie virtuelle',
          tag: '~60 jours ouvrés*',
          actionRequiredTag: 'Action requise de votre part',
          descriptionSelfInstalled: [
            "En tant qu'autoposeur, quelques étapes sont nécessaires pour activer votre batterie virtuelle. Nos équipes vous guident pas à pas ",
            'depuis votre espace client',
            '.',
          ],
          descriptionInstaller:
            "Votre installateur va compléter le dossier d'activation directement depuis son espace professionnel. Vous n'avez rien à faire, nous vous préviendrons dès que votre batterie virtuelle sera active.",
        },
      },
      preloadedBatteryOfferNextSteps: {
        subscription: {
          title: 'Souscription validée',
          tag: 'Maintenant',
          description: [
            'Votre contrat vous a été envoyé par email. Vous continuez avec ',
            'votre fournisseur habituel',
            ' sans interruption.',
          ],
        },
        enedisFile: {
          title: "Finalisation du dossier d'activation auprès d'Enedis",
          tag: 'Prochaines semaines',
          actionRequiredInstallerTag: 'Action requise de votre installateur',
          actionRequiredSelfInstalledTag: 'Action requise de votre part',
          descriptionInstaller:
            "Nous collectons auprès de votre installateur les documents nécessaires et lançons les démarches auprès d'Enedis.",
          descriptionSelfInstalled:
            "En tant qu'autoposeur, vous devez nous fournir tous les documents nécessaires afin que nous puissions lancer les démarches auprès d'Enedis.",
        },
        battery: {
          title: 'Activation de votre batterie virtuelle',
          tag: '1er avril 2027 *',
          description:
            'Lancement officiel du contrat avec mylight150 et mise en route du stockage virtuel. Votre batterie est pleine, vous pouvez en profiter pleinement !',
        },
        disclaimerInstaller:
          "*Date soumise à la bonne réception des documents nécessaires de la part de votre installateur, et à la validation de votre mise en injection par Enedis. En cas de délai administratif supplémentaire, l'activation est décalée d'autant — et vous ne payez toujours pas d'abonnement entre-temps.",
        disclaimerSelfInstalled:
          "*Date soumise à la bonne réception des documents nécessaires et à la validation de votre mise en injection par Enedis. En cas de délai administratif supplémentaire, l'activation est décalée d'autant — et vous ne payez toujours pas d'abonnement entre-temps.",
      },
      appDownload: {
        title: "Téléchargez l'application",
        apple: {
          heading: 'iOS — App Store',
        },
        google: {
          heading: 'Android — Google Play',
        },
      },
    },
    electricitySupplier: {
      title: "Choisissez votre fourniture d'électricité",
      contractedPower: {
        title: 'Puissance souscrite',
        description:
          'En choisissant la puissance la plus adaptée à vos besoins, vous optimisez à la fois votre confort et vos économies. Pour vous aider, consultez notre article :',
        link: 'Comment choisir la puissance souscrite idéale ?',
        form: {
          select: {
            placeholder: 'Sélectionner la puissance',
            optionsLabel: '{size} kVA',
          },
        },
      },
      greenOffer: {
        title: ['Avec mylight150, votre électricité est', 'verte et française'],
        description: "Pour chaque MWh consommé, une garantie d'origine française est utilisée.",
        welcomeOffer: {
          label: 'Offre de bienvenue : ',
          description:
            'Profitez en, le prix du kWh est identique au Tarif Réglementé de Vente pendant 1 an !',
        },
      },
      pricingOption: {
        label: 'Offre tarifaire',
        offPeakAndPeakHours: 'Heures creuses / pleines',
        offPeakAndPeakHoursDescription:
          'Un prix réduit pendant 8h par jour (la nuit et parfois l’après-midi) et un prix plus élevé le reste du temps',
        base: 'Base',
        baseDescription:
          'Un prix unique toute la journée, quelque soit l’heure à laquelle vous consommez.',
        tag: 'Vert de France',
        link: 'Quelle offre est la plus intéressante pour votre cas ?',
        alert: "Pour une puissance de 3 kVA, seule l'offre tarifaire Base est disponible",
        priceAlert: {
          title: 'Vos prix avec l’offre de bienvenue :',
          base: 'Prix unique : <strong>{discountedPrice}€ /kWh</strong> pendant 1 an.',
          offPeakAndPeakHours: `<ul>
            <li>Heures creuses : <strong>{offPeakDiscountedPrice}€ /kWh</strong> pendant 1 an.</li>
            <li>Heures pleines : <strong>{peakDiscountedPrice}€ /kWh</strong> pendant 1 an.</li>
          </ul>`,
        },
      },
      subscriptionPrice: {
        label: "Votre abonnement de fourniture d'électricité",
        unit: '/mois (TTC)',
      },
      whyTwoSubscriptions: {
        title: 'Pourquoi je paye deux abonnements ?',
        description: 'Deux services, deux abonnements :',
        electricitySupply:
          "La fourniture d'électricité (votre abonnement réseau + le kWh consommé) : elle prend le relais quand vos panneaux ne produisent pas et votre batterie virtuelle est vide.",
        virtualStorage:
          "Le stockage virtuel : lui, met de côté votre surplus solaire pour vous le restituer plus tard, à la place d'électricité achetée sur le réseau.",
      },
      api: {
        errors: {
          patchSubscriptionEnergyOfferInformations:
            'Erreur lors de la sauvegarde des informations énergétiques de souscription',
          getSubscriptionContractedPowersChoices:
            'Erreur lors de la récupération des puissances souscrites',
        },
      },
    },
  },
};
